import axios from "axios";

// export const baseUrl="http://192.168.1.3:6070/";
// export const baseUrl="https://msl.kidsdal.com/";
export const baseUrl="/";
// export const baseUrl="http://localhost:6072/"

export const loginApi = async (msisdn) => {
    const response = await axios.post(`${baseUrl}api/v1/login`, {
        msisdn: msisdn
    });
    return response;
};

export const getImagesApi=async()=>{
    const response=await axios.get(`${baseUrl}api/v1/get-images`);
    return response;
}

export const getVideosApi=async(token)=>{
    const response=await axios.get(`${baseUrl}api/v1/protected/get-videos`,{
        headers:{
            Authorization:`Bearer ${token}`
        }
    });
    return response;
}

const Integrated_API_URL = "https://api-msl.kidsdal.com/";

export const SendOtpAPI = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/SendOTP`, {
        msisdn
    });
    return response;
}

export const VerifyOtpAPI = async (msisdn, otp,otp_ref,ext_ref) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/verifyOTP`, {
        msisdn,
        otp_ref,
        otp,
        ext_ref
    });
    return response;
}

export const SubscriptionLogsApi=async(msisdn)=>{
     const response = await axios.post(`${Integrated_API_URL}subscription-logs`, {
        msisdn,
    });
    return response;
}

export const unsubscribeAPI=async(msisdn)=>{
    const response=await axios.post(`${Integrated_API_URL}deactivate-user`,{msisdn});
    return response;
}